import { formatFileSize } from "@/src/shared/utils/filesize";

interface FileUploadDescriptionTranslations {
  supportedFormats: string;
  maxFileSize: string;
}

interface FileUploadDescriptionOptions {
  acceptAttribute: string;
  maxFileSize?: number;
  description?: string;
  translations: FileUploadDescriptionTranslations;
}

export function buildFileUploadDescription({
  acceptAttribute,
  maxFileSize,
  description,
  translations,
}: FileUploadDescriptionOptions): string {
  if (description !== undefined) return description;

  return [
    supportedFormatsText(acceptAttribute, translations.supportedFormats),
    maxFileSizeText(maxFileSize, translations.maxFileSize),
  ]
    .filter(Boolean)
    .join(" ");
}

function maxFileSizeText(maxFileSize: number | undefined, template: string): string {
  if (maxFileSize === undefined) return "";

  return template.replace("%{max_file_size}", () => formatFileSize(String(maxFileSize)));
}

function supportedFormatsText(acceptAttribute: string, template: string): string {
  const formats = acceptAttribute
    .split(",")
    .map(item => item.trim())
    .filter(Boolean)
    .map(formatAcceptedType);

  if (!formats.length) return "";

  return template.replace("%{formats}", () => formats.join(", "));
}

function formatAcceptedType(acceptedType: string): string {
  if (acceptedType.startsWith(".")) return acceptedType.slice(1).toUpperCase();
  if (acceptedType.includes("/")) {
    const subtype = acceptedType.split("/")[1]?.replace("*", "").toUpperCase();

    return subtype || acceptedType;
  }

  return acceptedType.toUpperCase();
}
